import { render, staticRenderFns } from "./ItensSelecao.vue?vue&type=template&id=7eae6913"
import script from "./ItensSelecao.vue?vue&type=script&setup=true&lang=js"
export * from "./ItensSelecao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports